module.exports = __webpack_public_path__ + "img/chrome_reset.54dae364.png";